import React from 'react';

import "./DocsList.scss";
import { docsBeam } from '../../../config/bifrost';
import { useBeam } from '@randajan/bifrost/client/react';
import { Button } from '@randajan/jet-react/dom/form';
import { page } from '@randajan/jet-react/base/page';

export const DocsList = (props) => {
    const { } = props;

    const { data: docs } = useBeam(docsBeam);

    return (
        <div className="DocsList">
            {docs?.map((doc)=>{
                return <Button key={doc.id} onSubmit={_=>page.set("search.cti", doc.webPath)}>{doc.name}</Button>
            })}
        </div>
    )
}

